module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "alost"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Also by New Academia Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RUSSIAN FUTURISM: A History")]), _vm._v(", by Vladimir Markov")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WORDS IN REVOLUTION: Russian Futurist Manifestoes 1912-1928")]), _vm._v(" A. Lawton and H. Eagle, eds., trs.")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MOSCOW BELIEVES IN TEARS: Russians and Their Movies")]), _vm._v(", by Louis Menashe")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IMAGING RUSSIA 2000: Film and Facts")]), _vm._v(", by Anna Lawton")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BEFORE THE FALL: Soviet Cinema in the Gorbachev Years")]), _vm._v(", by Anna Lawton")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WE’RE FROM JAZZ: Festschrift in Honor of Nicholas V. Galichenko")]), _vm._v(" Megan Swift and Serhy Yekelchyk, eds.")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NEW PERSPECTIVES ON SOVIETIZATION IN CENTRAL AND EASTERN EUROPE AFTER WORLD WAR II")]), _vm._v(", Balázs Apor, Péter Apor and E. A. Rees, eds.")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("THE INNER ADVERSARY: The Struggle against Philistinism as the Moral Mission of the Russian Intelligentsia")]), _vm._v(", by Timo Vihavainen")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RED ATTACK WHITE RESISTANCE")]), _vm._v(", by Peter Kenez")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RED ADVANCE WHITE DEFEAT")]), _vm._v(", by Peter Kenez")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ASPECTS OF BALKAN CULTURE: Social, Political, and Literary Perceptions")]), _vm._v(" by Jelena Milojković-Djurić")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SLAVIC THINKERS OR THE CREATION OF POLITIES: Intellectual History and Political Thought in Central Europe and the Balkans in the 19th Century")]), _vm._v(" by Josette Baer")]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ON THE WAY TO RED SQUARE")]), _vm._v(", by Julieta Almeida Rodrigues")]), _vm._v(" "), _c('p', {
    staticClass: "also1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Memoirs")])]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("THROUGH DARK DAYS AND WHITE NIGHTS: Four Decades Observing a Changing Russia")]), _vm._v(", by Naomi F. Collins")]), _vm._v(" "), _c('p', {
    staticClass: "also"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JOURNEYS THROUGH VANISHING WORLDS")]), _vm._v(", by Abraham Brumberg")]), _vm._v(" "), _c('p', {
    staticClass: "also2"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.newacademia.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.newacademia.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fac3696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Also.vue
// module id = 63
// module chunks = 0